import BannerAcceptComCom from './styled';

export default BannerAcceptComCom;
